/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetProvidersSuccessfulActionPayload,
  GetProviderByIdActionPayload,
  GetProviderByIdSuccessfulActionPayload,
  CreateProviderActionPayload,
  CreateProviderSuccessfulActionPayload,
  UpdateProviderActionPayload,
  UpdateProviderSuccessfulActionPayload,
  DeleteProviderActionPayload,
  DeleteProviderSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/provider-data-store';

/* action types */
export enum ActionTypes {
  GetProviders = '[PROVIDER] GetProviders',
  GetProvidersSuccessful = '[PROVIDER] GetProvidersSuccessful',
  GetProvidersFailure = '[PROVIDER] GetProvidersFailure',
  GetProviderById = '[PROVIDER] GetProviderById',
  GetProviderByIdSuccessful = '[PROVIDER] GetProviderByIdSuccessful',
  GetProviderByIdFailure = '[PROVIDER] GetProviderByIdFailure',
  CreateProvider = '[PROVIDER] CreateProvider',
  CreateProviderSuccessful = '[PROVIDER] CreateProviderSuccessful',
  CreateProviderFailure = '[PROVIDER] CreateProviderFailure',
  UpdateProvider = '[PROVIDER] UpdateProvider',
  UpdateProviderSuccessful = '[PROVIDER] UpdateProviderSuccessful',
  UpdateProviderFailure = '[PROVIDER] UpdateProviderFailure',
  DeleteProvider = '[PROVIDER] DeleteProvider',
  DeleteProviderSuccessful = '[PROVIDER] DeleteProviderSuccessful',
  DeleteProviderFailure = '[PROVIDER] DeleteProviderFailure',
  ResetState = '[PROVIDER] ResetState',
}

/* actions */

/* This event gets the all Providers. */
export const GetProviders = createAction(ActionTypes.GetProviders);

/* This event is fired after getting all the Providers successfully. */
export const GetProvidersSuccessful = createAction(
  ActionTypes.GetProvidersSuccessful,
  props<{ payload: GetProvidersSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the Providers. */
export const GetProvidersFailure = createAction(
  ActionTypes.GetProvidersFailure,
);

/* This event gets the Provider by Provider id. */
export const GetProviderById = createAction(
  ActionTypes.GetProviderById,
  props<{ payload: GetProviderByIdActionPayload }>(),
);

/* This event is fired after getting all the Provider by Provider id successfully. */
export const GetProviderByIdSuccessful = createAction(
  ActionTypes.GetProviderByIdSuccessful,
  props<{ payload: GetProviderByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Provider by Provider id successfully. */
export const GetProviderByIdFailure = createAction(
  ActionTypes.GetProviderByIdFailure,
);

/* This event creates a Provider. */
export const CreateProvider = createAction(
  ActionTypes.CreateProvider,
  props<{ payload: CreateProviderActionPayload }>(),
);

/* This event is fired after creating a Provider successfully. */
export const CreateProviderSuccessful = createAction(
  ActionTypes.CreateProviderSuccessful,
  props<{ payload: CreateProviderSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a Provider successfully. */
export const CreateProviderFailure = createAction(
  ActionTypes.CreateProviderFailure,
);

/* This event updates a Provider. */
export const UpdateProvider = createAction(
  ActionTypes.UpdateProvider,
  props<{ payload: UpdateProviderActionPayload }>(),
);

/* This event is fired after updating a Provider successfully. */
export const UpdateProviderSuccessful = createAction(
  ActionTypes.UpdateProviderSuccessful,
  props<{ payload: UpdateProviderSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a Provider successfully. */
export const UpdateProviderFailure = createAction(
  ActionTypes.UpdateProviderFailure,
);

/* This event deletes a Provider. */
export const DeleteProvider = createAction(
  ActionTypes.DeleteProvider,
  props<{ payload: DeleteProviderActionPayload }>(),
);

/* This event is fired after deleting a Provider successfully. */
export const DeleteProviderSuccessful = createAction(
  ActionTypes.DeleteProviderSuccessful,
  props<{ payload: DeleteProviderSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a Provider successfully. */
export const DeleteProviderFailure = createAction(
  ActionTypes.DeleteProviderFailure,
);

/* This event resets the Provider state. */
export const ResetState = createAction(ActionTypes.ResetState);
